import { URL_TYPES } from '@wix/wix-vod-constants/dist/common/url-types';
import * as objectUtils from '@wix/wix-vod-shared/dist/src/common/utils/object';
import { CHANNEL_TYPES } from '@wix/wix-vod-constants/dist/common/channel-types';

export function parseYoutubeChannel(urlType, channelData) {
  const {
    id: externalId,
    snippet = {},
    contentDetails = {},
    statistics = {},
    brandingSettings = {},
    isExternalRemoved = false,
  } = channelData;

  const { title, description, thumbnails, publishedAt } = snippet;
  const { itemCount, relatedPlaylists = {} } = contentDetails;
  const videosCount = Number(itemCount || statistics.videoCount) || 0;
  const thumbnailUrl = getThumbnail(thumbnails) || null;

  let coverUrl =
    _.get(brandingSettings, 'image.bannerTvImageUrl') || thumbnailUrl;
  if (urlType === URL_TYPES.PLAYLIST && videosCount === 0) {
    coverUrl = null;
  }

  return objectUtils.removeUndefinedValues({
    externalId,
    uploadsPlaylistId: relatedPlaylists.uploads,
    title,
    description,
    thumbnailUrl,
    coverUrl,
    videosCount,
    externalCreatedTs: new Date(publishedAt),
    channelType: CHANNEL_TYPES.YOUTUBE_FEED,
    urlType,
    isExternalRemoved,
  });
}

const THUMBNAIL_SIZES = ['high', 'medium', 'standard', 'default'];

function getThumbnail(thumbnails) {
  if (!thumbnails) {
    return;
  }

  const biggestThumbByWidth = _(thumbnails)
    .values()
    .maxBy('width');

  const biggestAvailableSize = _(THUMBNAIL_SIZES)
    .takeWhile(size => _.has(thumbnails, size))
    .head();

  const biggestThumbnail =
    biggestThumbByWidth || thumbnails[biggestAvailableSize];

  return biggestThumbnail && biggestThumbnail.url.replace(/^https?:/, '');
}
